module.exports = __webpack_public_path__ + "static/media/skull-crossbones-white.dc8a9d6b.svg";